import React from "react";
import { useDraggable } from "@dnd-kit/core";
import "./Draggable.css";

const Draggable = ({ id, content, styles, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const combinedStyles = {
    ...styles,
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
  };

  const handleDeleteClick = (event) => {
    event.stopPropagation(); // Prevent the event from bubbling up to the draggable item
    onDelete(id);
  };

  return (
    <div ref={setNodeRef} style={combinedStyles} className="draggable" {...attributes} {...listeners}>
      {/* Render content safely, with the assumption that it's already formatted (including links) */}
      <div className="draggable-content">{content}</div>
      <button className="delete-button" onClick={handleDeleteClick}>
        x
      </button>
    </div>
  );
};

export default Draggable;
